import { appendAspectRatioToFileName as e } from "../../utils/aspect-ratio.mjs";
import { replaceImageFileBlob as t } from "../../utils/replace-file-blob.mjs";
import { memo as n, useRef as r } from "react";
import { jsx as i, jsxs as a } from "react/jsx-runtime";
import o from "react-cropper";
//#region src/modules/image-cropper/image-cropper.tsx
var s = n(({ imageCropperRef: n, isRounded: s, imageFile: c, imageCropperProps: l }) => {
	let { viewMode: u = 1, autoCropArea: d = 1, aspectRatio: f = 1, checkOrientation: p = !1, background: m = !0, dragMode: h = "move", toggleDragModeOnDblclick: g = !1, style: _ = {
		height: 400,
		width: "100%"
	}, ...v } = l || {}, y = r(null), b = r(null), x = r(null), S = r(null);
	return n && (n.current = {
		hidePreview: () => {
			b.current && (b.current.style.opacity = ""), x.current && (x.current.style.display = "block"), S.current && (S.current.style.zIndex = "", S.current.innerText = "");
		},
		showPreview: () => {
			x.current && S.current && (S.current.appendChild(x.current.cloneNode(!0)), S.current.style.zIndex = "1000", x.current.style.display = "none"), b.current && (b.current.style.opacity = "0");
		},
		getCroppedFile: (n) => new Promise((r, i) => {
			try {
				let a = y.current?.cropper;
				if (!a) throw Error();
				if (s) {
					let n = a?.getCroppedCanvas();
					if (!n) throw Error();
					let o = Math.min(n.width, n.height), s = document.createElement("canvas");
					s.width = o, s.height = o;
					let l = s.getContext("2d");
					if (!l) throw Error();
					l.beginPath(), l.arc(o / 2, o / 2, o / 2, 0, Math.PI * 2), l.closePath(), l.clip(), l.drawImage(n, 0, 0, o, o), s.toBlob((n) => {
						if (!c || !n) return i(/* @__PURE__ */ Error());
						r(e(t(c, n), f));
					});
				} else a.getCroppedCanvas(n).toBlob((n) => {
					if (!c || !n) return i(/* @__PURE__ */ Error());
					r(e(t(c, n), f));
				});
			} catch (e) {
				i(e);
			}
		})
	}), /* @__PURE__ */ i("div", { children: /* @__PURE__ */ a("div", {
		className: "relative w-full overflow-hidden",
		children: [
			/* @__PURE__ */ i("div", {
				ref: S,
				className: "absolute inset-0 flex items-center justify-center"
			}),
			/* @__PURE__ */ i("div", {
				ref: x,
				style: {
					position: "absolute",
					overflow: "hidden",
					width: _.width,
					height: _.height,
					borderRadius: s ? "50%" : 0
				}
			}),
			/* @__PURE__ */ i("div", {
				ref: b,
				children: /* @__PURE__ */ i(o, {
					className: s ? "sio-cropper-rounded" : "",
					ref: y,
					src: c && URL.createObjectURL(c),
					preview: x || void 0,
					style: _,
					viewMode: u,
					background: m,
					autoCropArea: d,
					aspectRatio: f,
					checkOrientation: p,
					dragMode: h,
					toggleDragModeOnDblclick: g,
					...v
				})
			})
		]
	}) });
});
s.displayName = "ImageCropper";
//#endregion
export { s as ImageCropper };
